import { OrderService } from '@business/services';
import React, { Fragment, memo } from 'react';

export interface HasOrderNameProps {
  children: React.ReactNode;
}

export const HasOrderName = memo((props: HasOrderNameProps) => {
  return <Fragment>{OrderService.isNameEnabled() ? props.children : ''}</Fragment>;
});
